import React from "react";
import CitySelection from "../3_organisms/CitySelection";

function HomeMain() {
  return (
    <div>
      <CitySelection />
    </div>
  );
}

export default HomeMain;
